import { KeyboardEvent } from "react";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { ButtonClickAnalyticsType, EventPlatformEntry } from "@kaltura/mediaspace-shared-types";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { Thumbnail } from "./styled-components";

interface EventListItemThumbnailProps {
    className?: string;
    entry: EventPlatformEntry;
    entryLink: string;
    disabled?: boolean;
    openInNewTab?: boolean;
    analyticsValue?: string;
}

/**
 * Clickable thumbnail for the session card.
 *
 * Note: the parent component is responsible for hiding the thumbnail on small breakpoints.
 */
export const EventListItemThumbnail = ({
    className = "",
    entry,
    entryLink,
    disabled,
    openInNewTab,
    analyticsValue,
}: EventListItemThumbnailProps) => {
    const config = useConfig();

    const showThumb = config.eventPlatform.eventListItem.showThumbnail;

    const sendButtonAnalytics = useButtonAnalytics();

    if (!showThumb) {
        return null;
    }

    // disable title click by tab in disabledMode
    const handleDisabledMode = (event: KeyboardEvent) => {
        if (disabled && event.key !== "Tab") {
            event.preventDefault();
        }
    };

    return (
        <a
            tabIndex={-1}
            href={entryLink}
            target={openInNewTab ? "_blank" : undefined}
            style={disabled ? { pointerEvents: "none" } : {}}
            onKeyDown={handleDisabledMode}
            className={`${className} kms-ds-event-list-item-image-wrapper`}
            onClick={() =>
                sendButtonAnalytics(analyticsValue ?? "Session card - Thumbnail", ButtonClickAnalyticsType.THUMBNAIL)
            }
        >
            <Thumbnail src={entry.thumbnailUrl} alt={entry.name} className={"kms-ds-event-list-item-image"} />
        </a>
    );
};
